/* eslint-disable consistent-return */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import TBody from "./TBody";

import { useWorkflow } from "../../../../../../context/WorkflowContext";
import { IActivityManagementWorkflow } from "../../../../../../context/interfaces/IWorkflowContext";
import TableStyles from "../../../../../../styles/components/TableStyles";
import DialogStyles from "../../../../../../styles/components/DialogStyles";
import ButtonStyles from "../../../../../../styles/components/ButtonStyles";
import { IActivities } from "../../../../interface/IActivities";
import ActivitiesManagementFormsStyles from "../../../../../../styles/pages/Workflows/ActivitiesManagementFormsStyles";
import PaginationLocal from "../../../../../../components/PaginationLocal";
import ActivityManagementWorkflowService from "../../../../../../service/Docente/ActivityManagementWorkflowService";
import GenericUtils from "../../../../../../utils/GenericUtils";

interface IModalProps {
    workflow: IActivityManagementWorkflow | null;
    handleChangeContent: (content: string) => void;
    changeModalTitle: (title: string) => void;
}

const { StyledContainerButton } = DialogStyles;
const { BtnPrimary } = ButtonStyles;

const PerformedActivities: React.FC<IModalProps> = ({
    workflow,
    handleChangeContent,
    changeModalTitle,
}) => {
    const { instance } = useMsal();
    const workflowContext = useWorkflow();
    const { processoId } = workflow || {};
    const { workflowTypeId } = workflowContext.workflowFilter || {};
    const [activitiesPerformed, setActivitiesPerformed] = useState<
        IActivities[]
    >([]);
    const [filteredActivities, setFilteredActivities] = useState<IActivities[]>(
        []
    );

    const getPerformedActivities = async () => {
        try {
            const getPerformedWorkflowResponse =
                await ActivityManagementWorkflowService.getPerformedWorkflow(
                    workflowTypeId,
                    processoId,
                    instance
                );

            if (
                GenericUtils.isSuccessStatus(
                    getPerformedWorkflowResponse.status
                )
            ) {
                const { cartoes } = getPerformedWorkflowResponse.data;
                return cartoes;
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    const handlePerformedActivities = async () => {
        changeModalTitle("Antecipações, Reposições e Substituições Realizadas");
        const performedActivities = await getPerformedActivities();

        setActivitiesPerformed(performedActivities);
        setFilteredActivities(performedActivities);
    };

    useEffect(() => {
        handlePerformedActivities();
    }, []);

    const listperformedActivities = filteredActivities &&
        filteredActivities.length && <TBody activities={filteredActivities} />;

    return (
        <>
            <p style={{ padding: "16px 0 40px 0" }}>
                Confira as reposições, antecipações e substituições realizadas
            </p>
            {activitiesPerformed && activitiesPerformed.length ? (
                <>
                    <TableStyles.TablePrimary
                        bordered
                        striped
                        responsive
                        style={{ marginBottom: 0 }}
                    >
                        <thead>
                            <tr>
                                <th>Tipo do Cartão</th>
                                <th>Nome da Atividade</th>
                                <th>Data</th>
                                <th>Alocação</th>
                            </tr>
                        </thead>
                        <tbody>{listperformedActivities}</tbody>
                    </TableStyles.TablePrimary>
                    <ActivitiesManagementFormsStyles.StyledPaginationContainer>
                        <PaginationLocal
                            items={activitiesPerformed}
                            itemsPage={10}
                            onPaginate={(activities) =>
                                setFilteredActivities(activities)
                            }
                            hidePagination={false}
                        />
                    </ActivitiesManagementFormsStyles.StyledPaginationContainer>
                </>
            ) : (
                <>
                    <p style={{ fontWeight: "bold" }}>
                        Não há atividades de reposição, antecipação ou
                        substituição neste período.
                    </p>
                    <p style={{ fontWeight: "bold" }}>
                        Você pode avançar para a próxima página para visualizar
                        outros tipos de atividades.
                    </p>
                </>
            )}
            <StyledContainerButton>
                <BtnPrimary
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => handleChangeContent("NOT_PERFORMED")}
                >
                    Avançar
                </BtnPrimary>
            </StyledContainerButton>
        </>
    );
};

export default PerformedActivities;
